
  (function() {
    var root = document.getElementById('jsq-nav-drawer');
    if (!root) return;

    var lastFocus = null;
    var suppressed = [];
    var closeTimer = null;
    var isOpen = false;
    var histEntry = false; /* AUDIT_V2 B6-007: drawer owns one history entry so Back closes it */
    var ignorePop = false;
    var previousHtmlOverflow = '';
    var previousBodyOverflow = '';
    var focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'summary',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    function visibleFocusables() {
      return Array.prototype.filter.call(root.querySelectorAll(focusableSelector), function(element) {
        return !element.hidden &&
          element.getAttribute('aria-hidden') !== 'true' &&
          element.getClientRects().length > 0 &&
          window.getComputedStyle(element).visibility !== 'hidden';
      });
    }

    function focusFirst() {
      if (!isOpen) return;
      var focusables = visibleFocusables();
      var target = focusables[0] || root.querySelector('.jsq-nav__panel');
      if (target && typeof target.focus === 'function') target.focus();
    }

    function suppressBackground() {
      var branch = root;
      suppressed = [];

      while (branch && branch !== document.body) {
        var parent = branch.parentElement;
        if (!parent) break;

        Array.prototype.forEach.call(parent.children, function(sibling) {
          if (sibling === branch || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return;

          suppressed.push({
            element: sibling,
            hadInert: sibling.hasAttribute('inert'),
            ariaHidden: sibling.getAttribute('aria-hidden')
          });

          sibling.setAttribute('inert', '');
          sibling.setAttribute('aria-hidden', 'true');
        });

        branch = parent;
      }
    }

    function restoreBackground() {
      suppressed.forEach(function(state) {
        if (!state.hadInert) state.element.removeAttribute('inert');

        if (state.ariaHidden === null) {
          state.element.removeAttribute('aria-hidden');
        } else {
          state.element.setAttribute('aria-hidden', state.ariaHidden);
        }
      });
      suppressed = [];
    }

    function open() {
      if (isOpen || window.innerWidth > 768) return;
      isOpen = true;
      window.clearTimeout(closeTimer);
      try { history.pushState({ jsqDrawer: 1 }, ''); histEntry = true; } catch (err) { histEntry = false; }

      lastFocus = document.activeElement;
      previousHtmlOverflow = document.documentElement.style.overflow;
      previousBodyOverflow = document.body.style.overflow;

      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      suppressBackground();

      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      var btn = document.getElementById('js-app-bar-menu');
      if (btn) btn.setAttribute('aria-expanded', 'true');

      requestAnimationFrame(function() {
        if (!isOpen) return;
        root.classList.add('is-open');
        requestAnimationFrame(focusFirst);
      });
    }

    function close(restoreFocus) {
      if (!isOpen) return;
      isOpen = false;
      window.clearTimeout(closeTimer);
      if (histEntry) {
        histEntry = false;
        if (history.state && history.state.jsqDrawer) { ignorePop = true; history.back(); }
      }

      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');

      document.documentElement.style.overflow = previousHtmlOverflow;
      document.body.style.overflow = previousBodyOverflow;
      restoreBackground();

      var btn = document.getElementById('js-app-bar-menu');
      if (btn) btn.setAttribute('aria-expanded', 'false');

      var returnTarget = lastFocus && lastFocus.isConnected && !lastFocus.disabled
        ? lastFocus
        : btn;
      if (restoreFocus !== false && returnTarget && returnTarget.getClientRects().length &&
          window.getComputedStyle(returnTarget).visibility !== 'hidden' && typeof returnTarget.focus === 'function') returnTarget.focus();

      if (restoreFocus === false) {
        root.hidden = true;
        return;
      }

      closeTimer = window.setTimeout(function() {
        if (!isOpen) root.hidden = true;
      }, 300);
    }

    root.addEventListener('click', function(e) {
      if (e.target.closest('[data-jsq-nav-close]')) close();
    });

    document.addEventListener('keydown', function(e) {
      if (!isOpen) return;

      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        close();
        return;
      }

      if (e.key !== 'Tab') return;

      var focusables = visibleFocusables();
      if (!focusables.length) {
        e.preventDefault();
        focusFirst();
        return;
      }

      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var active = document.activeElement;

      if (!root.contains(active)) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
      } else if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    }, true);

    document.addEventListener('focusin', function(e) {
      if (isOpen && !root.contains(e.target)) {
        e.stopPropagation();
        focusFirst();
      }
    }, true);

    window.addEventListener('popstate', function() {
      if (ignorePop) { ignorePop = false; return; }
      if (isOpen) { histEntry = false; close(); }
    });

    window.addEventListener('resize', function() {
      if (window.innerWidth > 768) close(false);
    });

    window.jsqNavDrawer = { open: open, close: close };
  })();
